import { Layout } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';

import { DialogHost } from '@/components/feedback/dialog';
import { useToast } from '@/components/feedback/toast';
import { routes } from '@/config/routes';
import { AUTH_POLICY, useLogout } from '@/features/auth';
import { useIdleTimeout } from '@/hooks/use-idle-timeout';
import { useAuth } from '@/providers/auth-provider';

import { ModuleHeaderProvider, PageHeader } from '../module-header';
import { PageContainer } from '../page-container';
import { Sidebar } from '../sidebar';

import styles from './app-shell.module.scss';

const { Content } = Layout;

export function AppShell() {
  const { rememberMe, clearSession } = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();
  const toast = useToast();

  useIdleTimeout({
    enabled: !rememberMe,
    timeoutMs: AUTH_POLICY.idleMs,
    onIdle: async () => {
      await logout.mutateAsync().catch(() => undefined);
      clearSession();
      navigate(routes.login);
      toast.info({ title: 'Your session has expired. Please log in.' });
    },
  });

  return (
    <ModuleHeaderProvider>
      <DialogHost>
        <Layout className={styles.shell}>
          <Sidebar />
          <Layout className={styles.main}>
            <Content className={styles.content}>
              <PageContainer>
                <PageHeader />
                <Outlet />
              </PageContainer>
            </Content>
          </Layout>
        </Layout>
      </DialogHost>
    </ModuleHeaderProvider>
  );
}
